<template>
    <div class="main-nav">
        <div class="section-head">
            <span class="section-title">应用分区</span>
            <span class="section-tag">实时更新</span>
        </div>
        <van-tabs
            swipeable
            lazy-render
            color="#0f5964"
            line-width="1rem"
            line-height="0.5rem"
            background="none"
            title-inactive-color="#6f6860"
            title-active-color="#0f5964"
            @click="getListClass">
            <van-tab v-for="item in classArr" :title="item.classify" :key="item.id"></van-tab>
        </van-tabs>

        <van-grid :column-num="5" :gutter="4" :border="false">
            <van-grid-item v-for="item in dataList" :key="item.id">
                <div class="item-image" @click="toPath(item)">
                    <img :src="item.pic" alt="">
                </div>
                <span class="item-title">{{ item.title }}</span>
            </van-grid-item>
        </van-grid>
    </div>
</template>

<script>
export default {
    data() {
        return {
            classArr: [
                { id: 1, classify: "分类1" },
                { id: 2, classify: "分类2" },
                { id: 3, classify: "分类3" },
            ],
            dataList: [],
        }
    },
    methods: {
        // 获取分类
        async getSet() {
            const { data: res } = await this.$http.get('/classify')
            this.classArr = res.data || []
            const first = this.classArr[0]
            if (first && first.classify) {
                this.getListClass("", first.classify)
            }
        },
        // 获取对应分类的应用
        async getListClass(name, title) {
            const { data: res } = await this.$http.get('/list_class',{
                params: {class: title}
            })
            this.dataList = res.data
        },
        // 直接跳转到应用下载链接并上报点击统计
        async toPath(itemInfo) {
            if (!itemInfo || !itemInfo.url) return

            try {
                await this.$http.post('/track_click', {
                    target_type: 'app',
                    target_id: itemInfo.id
                })
            } catch (error) {
                // 统计失败不阻断下载跳转
            }

            window.open(itemInfo.url, '_blank')
        }
    },
    created() {
        this.getSet()
    }
}
</script>

<style lang="less" scoped>
.main-nav {
    border-radius: var(--a-radius);
    padding: .75rem;
    background: var(--a-surface);
    border: 1px solid rgba(255, 255, 255, .65);
    box-shadow: var(--a-shadow);
}

.section-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .35rem;
}

.section-title {
    font-size: 1.05rem;
    font-weight: 800;
    color: #173d42;
}

.section-tag {
    font-size: .75rem;
    color: #fff;
    background: linear-gradient(120deg, #0f5964, #dd6f24);
    border-radius: 999px;
    padding: .2rem .6rem;
}

/deep/ .van-tab {
    justify-content: flex-start;
    -webkit-justify-content: flex-start;
    flex: none;
    -webkit-box-flex: none;
    margin-right: .8rem;
    padding-left: 0;
}

/deep/ .van-tab--active {
    font-weight: 800;
}

/deep/ .van-tab__text--ellipsis {
    font-size: 13px;
    font-weight: 700;
    line-height: 2rem;
}

/deep/ .van-tabs__nav--line {
    box-sizing: content-box;
    height: auto;
    padding-bottom: 6px;
}

/deep/ .van-tabs__wrap {
    height: 2.8rem;
}

/deep/ .van-grid-item__content {
    padding: 5px 4px;
    background: linear-gradient(180deg, #fff, #fff8f1);
    border-radius: .6rem;
    border: 1px solid rgba(15, 89, 100, .1);
    box-shadow: 0 8px 20px rgba(15, 89, 100, .09);
}

.item-image {
    width: 100%;
    aspect-ratio: 1 / 1;
    overflow: hidden;
    border-radius: .45rem;
    cursor: pointer;
    background: linear-gradient(180deg, #f4f0e7, #fefcf7);
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
        transition: all .35s;
        &:hover {
            transform: scale(1.1);
        }
    }
}

.item-title {
    color: #574f45;
    font-size: .84rem;
    font-weight: 600;
    padding-top: .18rem;
    text-align: center;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>